import { useMemo } from 'react';
import useIsMobileDevice from '@/hooks/useIsMobileDevice';
import styles from './index.module.scss';

export default function ButtonShowNewNotes ({
  onClick,
  quantity,
}: {
  onClick: () => void;
  quantity: number;
}) {
  const { isMobile } = useIsMobileDevice();
  const notesQuantityLabel = useMemo(() => quantity.toString(), [quantity]);
  const topWrapperNavigationHeightMobile = useMemo(() => {
    try {
      if (quantity === 0 || !isMobile) {
        throw new Error();
      }

      if (window.getComputedStyle(document.querySelector('#top_wrapper.top_wrapper--capOrNavbarHidden > .main-navigation')!).zIndex === '-1') {
        return '60px';
      } else {
        return '40px';
      }
    } catch {
      return undefined;
    }
  }, [quantity, isMobile]);

  return (
    <div className={styles['button-show-new-notes-wrapper']} style={{ '--top-wrapper-navigation-height-mobile': topWrapperNavigationHeightMobile } as React.CSSProperties}>
      <button
        className={styles['button-show-new-notes']}
        data-e='new-notes-info-btn'
        onClick={onClick}
        type='button'
      >
        Zobacz nowe wiadomości
        <span className={styles['button-show-new-notes__number']}>({notesQuantityLabel})</span>
      </button>
    </div>
  );
}
